<template>

  <div class="bjlsc">
    <headerBanner :bannerUrl='domain+data.bgpic'></headerBanner>
    <div class="common_title clearfix">
      <!-- <div class="icon"><i class="icons i9"></i></div> --><p>{{data.name}}</p>
    </div>

    <div class="about_detail" v-html='data.content'>
     

    </div>
  </div>
</template>


<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'report',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      url:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:21
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.cate
        //  if(this.data.fileurl){
        //   this.url = this.domain+this.data.fileurl
        // }else{
        //   this.url = 'javascript:;'
        // }
         
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i9{
    width: 0.38rem;
    height: 0.4rem;
    background-position: -2.18rem -0.1rem;
  }
  .about_detail{
    padding: 0 0.36rem;
    
  }
  .about_detail p{
    font-size: 0.2rem;
    color: #000;
    margin-bottom: 0.1rem;
  }
  .about_detail img{
    width: 5.48rem;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.2rem;
  }
  .about_contact_title{
    font-size: 0.28rem;
    color: #000;
    font-weight: bold;
    margin-bottom: 0.1rem;
  }
  .about_address_item p.name{
    color: #6d6e71;
    font-size: 0.22rem;
  }
  p.address_title{
    font-size: 0.2rem;
    color: #000;
    margin-bottom: 0.2rem;
  }
  .about_address_item p{
    line-height: 0.2rem;
  }
  .about_address_wrap{
    margin-bottom: 0.6rem;
  }
  .about_address_item{
    width: 50%;
    float: left;
    margin-bottom: 0.3rem;
    height: 1rem;
    font-size: 0.2rem;
    color: 000;
  }
  .contact_icon{
    padding-top: 0.15rem;
    padding-left: 0.5rem;
    border-top: 0.02rem solid #ffd200;
    border-bottom: 0.02rem solid #ffd200;
  }
  .contact_icon img{
    width: 4rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/report.vue